import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";


const Footer = () => {
  return (
    <div>
      <footer className="bg-green-600 py-12 px-6 text-white text-center lg:flex items-center space-y-8">
        <div className="container mx-auto">
          <p>&copy; 2024 υγεία.</p>
        </div>

        <div className="container mx-auto mt-4">
          <a href="#" className="mr-4">
            Privacy Policy
          </a>
          |
          <a href="#" className="mr-4 ml-4">
            Terms & Conditions
          </a>
          
        </div>

        {/* <div className="container mx-auto mt-4">
          <p>
            The information provided on this website is for informational
            purposes only and is not intended as a substitute for professional
            medical advice, diagnosis, or treatment. Please consult your
            healthcare provider with questions concerning any medical condition.
            While we try to update our content often, medical information
            changes rapidly. Therefore, some information may be out of date.
          </p>
        </div> */}

        <div className="container mx-auto mt-4">
          
          <div className="flex justify-center space-x-6 mt-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-300"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-300"
            >
              <FaTwitter />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-300"
            >
              <FaInstagram />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-300"
            >
              <FaLinkedinIn />
            </a>
          </div>
         
        </div>
      </footer>
    </div>
  );
}

export default Footer

// const Footer = () => {
//   return (
//     <footer className="bg-green-600 text-white ">
//       <div className="container text-center grid grid-cols-3">
//         <div>
//           <p className="">
//             &copy; 2024 υγεία. The content on this website is owned by AAU
//             Holdings OFC and our licensors. Do not copy any content (including
//             images) without our consent. Designed by AAU Holdings.
//           </p>
//         </div>

       
//           <div className="flex justify-center mt-4">
//             <a href="#" className="mr-4">
//               Privacy Policy
//             </a>
//             |
//             <a href="#" className="mr-4 ml-4">
//               Terms & Conditions
//             </a>
//             |
//             <a href="#" className="mr-4 ml-4">
//               Contact Us
//             </a>
//           </div>
    

//         <div className="">
//           <p>
//             The information provided on this website is for informational
//             purposes only and is not intended as a substitute for professional
//             medical advice, diagnosis, or treatment. Please consult your
//             healthcare provider with questions concerning any medical condition.
//             While we try to update our content often, medical information
//             changes rapidly. Therefore, some information may be out of date.
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
